var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.58984C14 8.24219 11.8398 10.375 9.1875 10.375C8.85938 10.375 8.55859 10.3477 8.28516 10.293L7.62891 11.0312C7.49219 11.168 7.32812 11.25 7.13672 11.25H6.125V12.3438C6.125 12.7266 5.82422 13 5.46875 13H4.375V14.0938C4.375 14.4766 4.07422 14.75 3.71875 14.75H0.65625C0.273438 14.75 0 14.4766 0 14.0938V11.9609C0 11.7969 0.0546875 11.6328 0.191406 11.4961L4.59375 7.09375C4.45703 6.60156 4.375 6.10938 4.375 5.5625C4.375 2.91016 6.50781 0.777344 9.16016 0.75C11.8398 0.75 14 2.91016 14 5.58984ZM9.1875 4.25C9.1875 4.98828 9.76172 5.5625 10.5 5.5625C11.2109 5.5625 11.8125 4.98828 11.8125 4.25C11.8125 3.53906 11.2109 2.9375 10.5 2.9375C9.76172 2.9375 9.1875 3.53906 9.1875 4.25Z",
    fill: "url(#paint0_linear_265_1848)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_265_1848",
    x1: 0,
    y1: 9,
    x2: 0,
    y2: 16.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC1E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.62998bd577d062b9bad623e0bdb07f3d.svg";
export { ForwardRef as ReactComponent };